import { SpaceMd } from "@nxt-costco-com/forge-design-tokens";
const SelectorRadioButtonGroupStyles = () => ({
  radioGroup: {
    display: "flex",
    flexDirection: "column",
    gap: SpaceMd
  }
});
export {
  SelectorRadioButtonGroupStyles
};
